import {get} from "lodash"

export default function getDataFromError(err: any, traceId: string, errorCode: string): {[key: string]: any} {
  const data =
    err.errorData || // already assigned
    get(err, "response.data.data") || // REST API response
    err.data || // simple assign
    {}

  return {...data, errorCode: `(Code: ${errorCode})`, traceId: `(TraceId: ${traceId})`}
}
